const en = {
  Inicio: "Home",
  "Iniciar sesión": "Login",
  "Nombre de usuario": "User name",
  Contraseña: "Password",
  "Recordar cuenta": "Remember login",
  Registrarse: "Register",
  "¿Olvidó su contraseña?": "Forgot password?",
  "¿Su cuenta está bloqueada?": "Your account is blocked?",
  "Usa otro servicio para iniciar sesión": "Use another service to login",
  "Términos de uso y condiciones": "Terms of use and conditions",
  Usuario: "User",
  Usuarios: "Users",
  Contactos: "Contacts",
  Contacto: "Contact",
  Empresas: "Companies",
  Empresa: "Company",
  "Agregar empresa": "Add company",
  "Editar empresa": "Edit company",
  Perfil: "Profile",
  "Cambiar Contraseña": "Change Password",
  Premium: "Premium",
  "Cerrar sesión": "Logout",
  Suscripciones: "Subscriptions",
  Protocolos: "Protocols",
  "Agregar protocolo": "Add protocol",
  Día: "Day",
  "Agregar Empresa": "Add Company",
  Eliminar: "Delete",
  Editar: "Edit",
  Cancelar: "Cancel",
  Buscar: "Search",
  "Buscar Medicamento para el paciente": "Search Patient's medicine",
  "Tenga en cuenta que solo podrá buscar medicamentos del país de origen del paciente":
    "Please note that you will only be able to search for medications from the patient's country of origin",
  Volver: "Back",
  Resultado: "Result",
  Monodroga: "Monodrug",
  "Marca comercial": "Commercial brand",
  Presentación: "Presentation",
  Potencia: "Presentation",
  "Monodroga o Marca Comercial": "Monodrug or Commercial brand",
  "Agregar suscripción": "Add subscription",
  "Editar suscripción": "Edit subscription",
  "Subir logo": "Upload logo",
  "Configuración de suscripción": "Subscription settings",
  "Nueva suscripción": "New subscription",
  "Agregar administrador": "Add administrator",
  "Información general": "General information",
  Módulos: "Modules",
  Instituciones: "Institutions",
  Profesionales: "Professionals",
  "Agregar módulos": "Add modules",
  "Editar módulos": "Edit modules",
  "Agregar institución": "Add institution",
  "Agregar profesional": "Add professional",
  "Agregar usuario": "Add user",
  "Subir archivo": "Upload file",
  Activo: "Active",
  "Asociar protocolo": "Asociate protocol",
  "Meses de subscripción": "Subscription months",
  "Reporte de nuevos usuarios": "New users report",
  "Código de subscripción": "Subscription code",
  "Automonitoreo de Saturación de Oxígeno":
    "Automonitoreo de Saturación de Oxígeno",
  "Estudio de Automonitoreo de Peso": "Estudio de Automonitoreo de Peso",
  "Estudio de Automonitoreo de Temperatura":
    "Estudio de Automonitoreo de Temperatura",
  "Seleccione las instituciones asociadas a su empresa. Los usuarios de sus suscripciones recibirán un mensaje para autorizar el acceso a su información personal por parte de las instituciones seleccionadas.":
    "Seleccione las instituciones asociadas a su empresa. Los usuarios de sus suscripciones recibirán un mensaje para autorizar el acceso a su información personal por parte de las instituciones seleccionadas.",
  "Seleccione los médicos que realizarán el seguimiento de sus pacientes. A los usuarios que acepten estas suscripciones se les agregarán estos médicos como contacto con permiso para ver sus datos.":
    "Seleccione los médicos que realizarán el seguimiento de sus pacientes. A los usuarios que acepten estas suscripciones se les agregarán estos médicos como contacto con permiso para ver sus datos.",
  Rol: "Role",
  "Fin vigencia": "End of validity",
  "Última actividad": "Last activity",
  "Invitado por": "Invited by",
  "¿Estás seguro de eliminar el registro?": "Are you sure deleting this row?",
  "Super admin": "Super admin",
  Administrador: "Administator",
  Coordinador: "Coordinator",
  Profesional: "Professional",
  Paciente: "Patient",
  administrador: "administator",
  coordinador: "coordinator",
  profesional: "professional",
  paciente: "patient",
  "Solicitudes pendientes": "Pending requests",
  "Reenviar invitación": "Resend invitation",
  "Buscar usuario": "Search user",
  Apellido: "Last name",
  Nombre: "First name",
  "Segundo Nombre": "Middle name",
  "Asignar como": "Assing as",
  Guardar: "Save",
  "El {0} se asignó exitosamente.": "{0} has been asigned successfully.",
  "El {0} se guardó exitosamente.": "{0} has been saved successfully.",
  "El {0} se envió exitosamente.": "{0} has been sent successfully.",
  "El {0} se eliminó exitosamente.": "{0} has been deleted successfully.",
  "El {0} se actualizó exitosamente.": "{0} has been updated successfully.",
  "El {0} se desvinculó exitosamente.": "{0} has been unlinked successfully.",
  "El {0} se realizó exitosamente.": "{0} has been done successfully.",
  "El {0} no pudo ser asignado.": "{0} was not asigned.",
  "El {0} no pudo ser guardado.": "{0} was not saved.",
  "El {0} no pudo ser enviado.": "{0} was not sent.",
  "El {0} no pudo ser eliminado.": "{0} was not deleted.",
  "El {0} no pudo ser actualizado.": "{0} was not updated.",
  "El {0} no pudo ser desvinculado.": "{0} was not unlinked.",
  "El {0} no pudo ser realizado.": "{0} was not made.",
  "La {0} se asignó exitosamente.": "{0} has been asigned successfully.",
  "La {0} se guardó exitosamente.": "{0} has been saved successfully.",
  "La {0} se envió exitosamente.": "{0} has been sent successfully.",
  "La {0} se elimino exitosamente.": "{0} has been deleted successfully.",
  "La {0} se actualizó exitosamente.": "{0} has been updated successfully.",
  "La {0} se desvinculó exitosamente.": "{0} has been unlinked successfully.",
  "La {0} se realizó exitosamente.": "{0} has been done successfully.",
  "La {0} no pudo ser asignada.": "{0} was not asigned.",
  "La {0} no pudo ser guardada.": "{0} was not saved.",
  "La {0} no pudo ser enviada.": "{0} was not sent.",
  "La {0} no pudo ser eliminada.": "{0} was not deleted.",
  "La {0} no pudo ser asociada.": "{0} was not asociated.",
  "La {0} no pudo ser actualizada.": "{0} was not updated.",
  "La {0} no pudo ser desvinculada.": "{0} was not unlinked.",
  "La {0} no pudo ser realizada.": "{0} was not made.",
  "Ocurrió un error durante el proceso de {0}.":
    "An error ocurred during the {0} process.",
  "Fecha de nacimiento": "Date of birth",
  "Debe ser mayor a 18 años": "Must be more than 18 years",
  "Todos los campos son requeridos.": "All field form are required.",
  "Los datos se actualizaron exitosamente.":
    "Your data has been updated successfully.",
  "No se pudieron actualizar los datos.": "The data was not updated",
  "Ocurrió un problema procesando los datos del formulario.":
    "There was a problem processing the form data.",
  Estado: "Status",
  "Enviar solicitud": "Send invitation",
  "Invitar usuario": "Invite user",
  "La invitación ha sido eliminada exitsamente.":
    "The invitation has been deleted successfully.",
  "La invitación no pudo ser eliminada.": "The invitation can not be deleted.",
  "Resumen individual": "Individual resume",
  "Ficha personal": "Personal details",
  "Notas del profesional": "Professional notes",
  "Nueva nota": "New note",
  "Enviar notificación": "Send notification",
  Título: "Title",
  título: "title",
  "El {0} ingresado no es válido": "The {0} is not valid",
  "No se pudieron guardar sus datos.": "Your data was not saved",
  invitación: "invitation",
  nota: "nota",
  Notificaciones: "Notifications",
  Remitente: "Sender",
  Nota: "Nota",
  Autor: "Author",
  Píldoras: "Pills",
  píldora: "pill",
  "Enviar pildora": "Send pill",
  Ordenar: "Order",
  "Ordenar (descendente)": "Click to sort descending",
  "Ordenar (ascendente)": "Click to sort ascending",
  "Cancelar orden": "Click to cancel sorting",
  Filtros: "Filter menu",
  Aceptar: "OK",
  Limpiar: "Reset",
  "No hay filtros": "No filters",
  "Seleccinar todos": "Select all items",
  "Buscar en filtros": "Search in filters",
  "cambio de rol": "rol change",
  Clonar: "Clone",
  clonación: "cloning",
  autoevaluación: "self-assessment",
  Telemedicina: "Telemedicine",
  "Sin remitente": "No sender",
  "Conectar {0}": "Connect {0}",
  "Buscar {0}": "Search {0}",
  "Nombre de {0}": "{0} name",
  protocolo: "protocol",
  "No se seleccionó un {0}.": "No {0} was selected",
  "No se pudo conectar el {0}.": "The {0} could not be connected.",
  "No se pudo desconectar el {0}.": "The {0} could not be disconnected.",
  "¿Está seguro de que quiere desvincular este protocolo de la suscripción?":
    "Are you sure you want to unlink this protocol from the subscription?",
  "Esta acción no se puede deshacer": "This action can not be undone",
  "¿Está seguro de seleccionar este protocolo como inicial de la suscripción?":
    "Are you sure to select this protocol as the initial of the subscription?",
  "Marcar como protocolo inicial": "Mark as initial protocol",
  "Categorías de Cápsulas strapi": "Strapi Capsules Categories",
  Coordinadores: "Coordinators",
  "No asociada": "Not associated",
  "No asociadas": "Not associated",
  Asociada: "Associated",
  Asociadas: "Associated",
  categoría: "category",
  categorías: "categories",
  "No encontramos categorías.": "Categories not found.",
  "Invitaciones pendientes": "Pending invitations",
  "Invitar profesional": "Invite professional",
  "Datos sensibles": "Sensitive data",
  "Cambiar logo": "Change logo",
  "Recibir notificaciones": "Receive notifications",
  "No recibir notificaciones": "Do not receive notifications",
  "Permitir invitar contactos": "Allow to invite contacts",
  "No permitir invitar contactos": "Do not allow to invite contacts",
  "Cambiar rol": "Change role",
};

export default en;
